import React from 'react';
import { Btn, Eyebrow } from '../design-system';

interface Props {
  eyebrow?: string;
  title: React.ReactNode;
  description: React.ReactNode;
  primaryCta: { label: React.ReactNode; to?: string; onClick?: () => void };
  secondaryCta?: { label: React.ReactNode; to: string };
  details?: { label: string; value: string }[];
  footnote?: React.ReactNode;
}

const CtaBlock: React.FC<Props> = ({
  eyebrow = 'next step',
  title,
  description,
  primaryCta,
  secondaryCta,
  details,
  footnote,
}) => {
  const hasRight = (details && details.length > 0) || !!footnote;
  return (
    <div className={hasRight ? 'cta-block' : 'cta-block cta-block--solo'}>
      <div>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h2 style={{ marginTop: 14 }}>{title}</h2>
        <p>{description}</p>
        <div className="cta-block__actions">
          {primaryCta.to ? (
            <Btn variant="primary" to={primaryCta.to}>
              {primaryCta.label} →
            </Btn>
          ) : (
            <Btn variant="primary" onClick={primaryCta.onClick}>
              {primaryCta.label}
            </Btn>
          )}
          {secondaryCta && (
            <Btn variant="ghost" to={secondaryCta.to}>
              {secondaryCta.label}
            </Btn>
          )}
        </div>
      </div>
      {hasRight && (
        <div className="cta-block__right">
          {details?.map(d => (
            <div className="cta-block__row" key={d.label}>
              <span>{d.label}</span>
              <b>{d.value}</b>
            </div>
          ))}
          {footnote && (
            <div style={{ marginTop: 10, color: 'var(--ink-mute)', fontSize: 11 }}>{footnote}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default CtaBlock;
